import { isSignatureAddressFieldRequired } from '@change-corgi/config/signatures';

export function isPostalCodeRequired({ countryCode }: Readonly<{ countryCode: string }>): boolean {
	return isSignatureAddressFieldRequired(countryCode, 'postal_code');
}
